import React from "react";
import { COMPANY } from "@/lib/apiClient";

/** Kop cetak (Nota A5 / Invoice A4) — logo + alamat + telp + email. */
export const PrintHeader = ({ right, compact = false }) => (
  <div
    style={{
      borderBottom: "3px solid #0f766e",
      paddingBottom: 8,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: 12,
    }}
  >
    <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
      <img
        src={COMPANY.logo}
        alt="PAS Percetakan"
        style={{ width: compact ? 46 : 62, height: "auto", objectFit: "contain" }}
      />
      <div>
        <div style={{ fontSize: compact ? 17 : 21, fontWeight: 700, color: "#0f766e" }}>
          {COMPANY.name}
        </div>
        <div style={{ fontSize: 9.5 }}>{COMPANY.tagline}</div>
        <div style={{ fontSize: 9.5 }}>{COMPANY.address}</div>
        <div style={{ fontSize: 9.5 }}>
          Telp/WA: {COMPANY.phone} · ✉ {COMPANY.email}
        </div>
      </div>
    </div>
    <div style={{ textAlign: "right" }}>{right}</div>
  </div>
);

/** Kop struk termal 58mm. */
export const StrukHeader = () => (
  <div style={{ textAlign: "center" }}>
    <img
      src={COMPANY.logo}
      alt="PAS Percetakan"
      style={{ width: 90, height: "auto", margin: "0 auto", display: "block" }}
    />
    <div style={{ fontWeight: 700, marginTop: 2 }}>{COMPANY.name}</div>
    <div style={{ fontSize: 8 }}>{COMPANY.tagline}</div>
    <div style={{ fontSize: 8 }}>{COMPANY.address}</div>
    <div style={{ fontSize: 8 }}>Telp/WA: {COMPANY.phone}</div>
    <div style={{ fontSize: 8 }}>✉ {COMPANY.email}</div>
  </div>
);
